'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Hls from 'hls.js';
import { useRouter, useSearchParams } from 'next/navigation';
import { ChevronDown, ChevronRight, X } from 'lucide-react';
function IconRefund(t0) {
  const $ = _c(34);
  const {
    size: t1,
    from: t2,
    to: t3
  } = t0;
  const size = t1 === undefined ? 36 : t1;
  const from = t2 === undefined ? "#34d399" : t2;
  const to = t3 === undefined ? "#059669" : t3;
  let t4;
  if ($[0] !== from) {
    t4 = from.replace("#", "");
    $[0] = from;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const id = `refund-${t4}`;
  let t5;
  if ($[2] !== from) {
    t5 = <stop offset="0%" stopColor={from} />;
    $[2] = from;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== to) {
    t6 = <stop offset="100%" stopColor={to} />;
    $[4] = to;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== id || $[7] !== t5 || $[8] !== t6) {
    t7 = <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">{t5}{t6}</linearGradient>;
    $[6] = id;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${id}sh`;
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <stop offset="0%" stopColor="rgba(255,255,255,0.5)" />;
    t10 = <stop offset="100%" stopColor="rgba(255,255,255,0)" />;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== t8) {
    t11 = <radialGradient id={t8} cx="0.3" cy="0.3" r="0.7">{t9}{t10}</radialGradient>;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t7) {
    t12 = <defs>{t7}{t11}</defs>;
    $[14] = t11;
    $[15] = t7;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `url(#${id})`;
  let t14;
  if ($[17] !== t13) {
    t14 = <path d="M 38 14 A 17 17 0 1 0 40 26" stroke={t13} strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.35" />;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = `url(#${id})`;
  let t16;
  if ($[19] !== t15) {
    t16 = <path d="M 33 8 L 39 14 L 33 20" stroke={t15} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.55" />;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = `url(#${id})`;
  let t18;
  if ($[21] !== t17) {
    t18 = <circle cx="24" cy="26" r="13" fill={t17} />;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  const t19 = `url(#${id}sh)`;
  let t20;
  if ($[23] !== t19) {
    t20 = <circle cx="24" cy="26" r="13" fill={t19} />;
    $[23] = t19;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  let t22;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <circle cx="24" cy="26" r="13" stroke="rgba(255,255,255,0.25)" strokeWidth="1" fill="none" />;
    t22 = <path d="M 20 21 H 28 M 20 25 H 28 M 22 21 C 26 21 26 28 22 28 H 21 L 27 33" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />;
    $[25] = t21;
    $[26] = t22;
  } else {
    t21 = $[25];
    t22 = $[26];
  }
  let t23;
  if ($[27] !== size || $[28] !== t12 || $[29] !== t14 || $[30] !== t16 || $[31] !== t18 || $[32] !== t20) {
    t23 = <svg width={size} height={size} viewBox="0 0 48 48" fill="none">{t12}{t14}{t16}{t18}{t20}{t21}{t22}</svg>;
    $[27] = size;
    $[28] = t12;
    $[29] = t14;
    $[30] = t16;
    $[31] = t18;
    $[32] = t20;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  return t23;
}
function IconPlaySpark(t0) {
  const $ = _c(23);
  const {
    size: t1,
    from: t2,
    to: t3
  } = t0;
  const size = t1 === undefined ? 36 : t1;
  const from = t2 === undefined ? "#FFD86B" : t2;
  const to = t3 === undefined ? "#F59E0B" : t3;
  let t4;
  if ($[0] !== from) {
    t4 = from.replace("#", "");
    $[0] = from;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const id = `play-${t4}`;
  let t5;
  if ($[2] !== from) {
    t5 = <stop offset="0%" stopColor={from} />;
    $[2] = from;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== to) {
    t6 = <stop offset="100%" stopColor={to} />;
    $[4] = to;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== id || $[7] !== t5 || $[8] !== t6) {
    t7 = <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1">{t5}{t6}</linearGradient></defs>;
    $[6] = id;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `url(#${id})`;
  let t9;
  if ($[10] !== t8) {
    t9 = <rect x="8" y="12" width="26" height="22" rx="4" fill={t8} opacity="0.35" transform="rotate(-8 21 23)" />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = `url(#${id})`;
  let t11;
  if ($[12] !== t10) {
    t11 = <rect x="10" y="14" width="28" height="22" rx="5" fill={t10} />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <rect x="10" y="14" width="28" height="11" rx="5" fill="rgba(255,255,255,0.18)" />;
    t13 = <path d="M 21 21 L 21 31 L 30 26 Z" fill="#1a1208" />;
    $[14] = t12;
    $[15] = t13;
  } else {
    t12 = $[14];
    t13 = $[15];
  }
  let t14;
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <g transform="translate(36 12)"><path d="M 0 -5 L 1 -1 L 5 0 L 1 1 L 0 5 L -1 1 L -5 0 L -1 -1 Z" fill="#fff" /></g>;
    t15 = <circle cx="42" cy="20" r="1.5" fill="#fff" opacity="0.8" />;
    $[16] = t14;
    $[17] = t15;
  } else {
    t14 = $[16];
    t15 = $[17];
  }
  let t16;
  if ($[18] !== size || $[19] !== t11 || $[20] !== t7 || $[21] !== t9) {
    t16 = <svg width={size} height={size} viewBox="0 0 48 48" fill="none">{t7}{t9}{t11}{t12}{t13}{t14}{t15}</svg>;
    $[18] = size;
    $[19] = t11;
    $[20] = t7;
    $[21] = t9;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  return t16;
}
function IconAutoPay(t0) {
  const $ = _c(36);
  const {
    size: t1,
    from: t2,
    to: t3
  } = t0;
  const size = t1 === undefined ? 36 : t1;
  const from = t2 === undefined ? "#c4b5fd" : t2;
  const to = t3 === undefined ? "#7c3aed" : t3;
  let t4;
  if ($[0] !== from) {
    t4 = from.replace("#", "");
    $[0] = from;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const id = `auto-${t4}`;
  let t5;
  if ($[2] !== from) {
    t5 = <stop offset="0%" stopColor={from} />;
    $[2] = from;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== to) {
    t6 = <stop offset="100%" stopColor={to} />;
    $[4] = to;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== id || $[7] !== t5 || $[8] !== t6) {
    t7 = <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1">{t5}{t6}</linearGradient></defs>;
    $[6] = id;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `url(#${id})`;
  let t9;
  if ($[10] !== t8) {
    t9 = <rect x="8" y="12" width="28" height="26" rx="4" fill={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <rect x="8" y="12" width="28" height="8" rx="4" fill="rgba(0,0,0,0.25)" />;
    t11 = <rect x="8" y="12" width="28" height="26" rx="4" stroke="rgba(255,255,255,0.2)" strokeWidth="1" fill="none" />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t10 = $[12];
    t11 = $[13];
  }
  let t12;
  let t13;
  if ($[14] !== from) {
    t12 = <rect x="14" y="9" width="3" height="6" rx="1" fill={from} />;
    t13 = <rect x="27" y="9" width="3" height="6" rx="1" fill={from} />;
    $[14] = from;
    $[15] = t12;
    $[16] = t13;
  } else {
    t12 = $[15];
    t13 = $[16];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <circle cx="14" cy="26" r="1.5" fill="rgba(255,255,255,0.45)" />;
    t15 = <circle cx="22" cy="26" r="1.5" fill="rgba(255,255,255,0.45)" />;
    t16 = <circle cx="30" cy="26" r="1.5" fill="rgba(255,255,255,0.45)" />;
    t17 = <circle cx="14" cy="32" r="1.5" fill="rgba(255,255,255,0.45)" />;
    t18 = <circle cx="22" cy="32" r="2.5" fill="#fff" />;
    t19 = <circle cx="30" cy="32" r="1.5" fill="rgba(255,255,255,0.45)" />;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
  } else {
    t14 = $[17];
    t15 = $[18];
    t16 = $[19];
    t17 = $[20];
    t18 = $[21];
    t19 = $[22];
  }
  let t20;
  if ($[23] !== from) {
    t20 = <circle cx="0" cy="0" r="7" fill="#0a0c14" stroke={from} strokeWidth="1.5" />;
    $[23] = from;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  let t22;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <path d="M -3 -1 A 3 3 0 1 1 -1 3" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" fill="none" />;
    t22 = <path d="M -4.2 -2.5 L -3 -1 L -1.5 -2" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none" />;
    $[25] = t21;
    $[26] = t22;
  } else {
    t21 = $[25];
    t22 = $[26];
  }
  let t23;
  if ($[27] !== t20) {
    t23 = <g transform="translate(31 31)">{t20}{t21}{t22}</g>;
    $[27] = t20;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== size || $[30] !== t12 || $[31] !== t13 || $[32] !== t23 || $[33] !== t7 || $[34] !== t9) {
    t24 = <svg width={size} height={size} viewBox="0 0 48 48" fill="none">{t7}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t23}</svg>;
    $[29] = size;
    $[30] = t12;
    $[31] = t13;
    $[32] = t23;
    $[33] = t7;
    $[34] = t9;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  return t24;
}
import { Barlow } from 'next/font/google';
import PaymentStatusUI from '@/components/payment/PaymentStatusUI';
import PaymentModal from '@/components/payment/PaymentModal';
import LoadingOverlay from '@/components/ui/LoadingOverlay';
import { APP_CONFIG, FALLBACK_UPI_ICON } from '@/constants/payment';
import { useSubscriptionPayment } from '@/hooks/useSubscriptionPayment';
import { useUserProfile } from '@/hooks/useUserProfile';
import { trackAnalyticsEvent } from '@/lib/analytics';
import { useBackgroundCache } from '@/lib/contexts/BackgroundCacheContext';
import { auth } from '@/lib/firebase';
import type { BannersResponse, CustomPageConfigResponse, PremiumPlansResponse, SettingsResponse } from '@/lib/api';
import { URL_PARAMS, buildRoute, buildUrlParams, resolveUtmTrackingParams } from '@/lib/url-utils';
import { isPremiumUser } from '@/lib/user-utils';
import { usePlayStoreRedirect } from '@/hooks/usePlayStoreRedirect';
import { toast } from 'sonner';
const barlow = Barlow({
  weight: ['600', '700', '800'],
  subsets: ['latin'],
  variable: '--font-barlow',
  display: 'swap'
});

// Social proof avatar assets from Figma (valid ~7 days from generation)
const IMG_AVATAR_1 = './men.svg';
const IMG_AVATAR_2 = './women.svg';
const HLS_URL = 'https://vz-47b37c32-44d.b-cdn.net/02cdc4fe-f169-4937-a6ef-17593f1db834/playlist.m3u8';
const VIDEO_POSTER = 'https://vz-47b37c32-44d.b-cdn.net/02cdc4fe-f169-4937-a6ef-17593f1db834/thumbnail_a971c20f.jpg';
type PaymentApp = 'PHONEPE' | 'GPAY' | 'PAYTM' | 'DEFAULT';
export interface V12SubscriptionContentProps {
  initialBanners: BannersResponse | null;
  initialConfig: CustomPageConfigResponse | null;
  initialPaymentApp: PaymentApp;
  initialPlans: PremiumPlansResponse | null;
  initialQuery: Record<string, string | undefined>;
  initialSelectedPlanIndex: number;
  initialSettings: SettingsResponse | null;
  isCoupon?: boolean;
  trialDays?: number;
  price?: number;
  planMonths?: number;
}
const CONTENT_ROUTE_KEYS = [URL_PARAMS.SHOW_ID, URL_PARAMS.EPISODE_NUMBER, URL_PARAMS.LINK_TOKEN];
const V12_COUPON_CODE = 'C7SN9S';
const V12_COUPON_ORIGINAL_PRICE = 699;
export default function V12SubscriptionContent(t0) {
  const $ = _c(236);
  const {
    initialPaymentApp,
    initialPlans,
    initialQuery,
    initialSelectedPlanIndex,
    initialSettings,
    isCoupon: t1,
    trialDays: t2,
    price: t3,
    planMonths: t4
  } = t0;
  const isCoupon = t1 === undefined ? false : t1;
  const trialDays = t2 === undefined ? 1 : t2;
  const price = t3 === undefined ? 699 : t3;
  const planMonths = t4 === undefined ? 3 : t4;
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    initializeCache
  } = useBackgroundCache();
  let t5;
  if ($[0] !== searchParams) {
    t5 = resolveUtmTrackingParams(searchParams);
    $[0] = searchParams;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const utmTrackingParams = t5;
  const videoRef = useRef(null);
  const videoLoadStart = useRef(0);
  const couponToastShownRef = useRef(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [defaultPaymentApp, setDefaultPaymentApp] = useState(initialPaymentApp);
  const [isMuted, setIsMuted] = useState(true);
  const {
    data: profileData
  } = useUserProfile();
  const {
    redirectToPlayStore
  } = usePlayStoreRedirect(searchParams);
  const {
    startPayment: paymentStartPayment,
    cancel: paymentCancel,
    isProcessing: paymentProcessing,
    status: paymentStatus,
    subscriptionId: paymentSubId,
    timer: paymentTimer
  } = useSubscriptionPayment();
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = typeof window !== "undefined" ? sessionStorage.getItem("landingPath") || "/" : "/";
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const currentPath = t6;
  let t7;
  if ($[3] !== initialPlans?.premiumPlan) {
    t7 = initialPlans?.premiumPlan || [];
    $[3] = initialPlans?.premiumPlan;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const plans = t7;
  let t8;
  if ($[5] !== searchParams) {
    t8 = searchParams.get(URL_PARAMS.PLAN);
    $[5] = searchParams;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const planIndex = t8;
  const parsedIndex = planIndex ? parseInt(planIndex, 10) : Number.NaN;
  let t9;
  if ($[7] !== initialSelectedPlanIndex || $[8] !== parsedIndex) {
    t9 = Number.isNaN(parsedIndex) ? initialSelectedPlanIndex : parsedIndex;
    $[7] = initialSelectedPlanIndex;
    $[8] = parsedIndex;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const selectedPlanIndex = t9;
  const settings = initialSettings?.setting;
  const user = profileData?.user;
  let t10;
  let t11;
  if ($[10] !== utmTrackingParams) {
    t10 = () => {
      trackAnalyticsEvent("WEB_SUBSCRIBE_PAGE_VISITED", utmTrackingParams);
    };
    t11 = [utmTrackingParams];
    $[10] = utmTrackingParams;
    $[11] = t10;
    $[12] = t11;
  } else {
    t10 = $[11];
    t11 = $[12];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[13] !== isCoupon) {
    t12 = () => {
      if (!isCoupon || couponToastShownRef.current) {
        return;
      }
      toast.success("Coupon Applied", {
        duration: 8000
      });
      couponToastShownRef.current = true;
    };
    t13 = [isCoupon];
    $[13] = isCoupon;
    $[14] = t12;
    $[15] = t13;
  } else {
    t12 = $[14];
    t13 = $[15];
  }
  useEffect(t12, t13);
  let t14;
  if ($[16] !== initializeCache || $[17] !== settings?.loginScreenThumbnailImage || $[18] !== settings?.loginScreenThumbnailVideo) {
    t14 = () => {
      const imageUrl = settings?.loginScreenThumbnailImage;
      const videoUrl = settings?.loginScreenThumbnailVideo;
      if (!imageUrl || typeof window === "undefined") {
        return;
      }
      let cancelled = false;
      const warmCache = () => {
        if (!cancelled) {
          initializeCache(imageUrl, videoUrl || "");
        }
      };
      const scheduleWarmCache = () => {
        const idleWindow = window as Window & {
          requestIdleCallback?: (cb: IdleRequestCallback, opts?: IdleRequestOptions) => number;
          cancelIdleCallback?: (h: number) => void;
        };
        if (idleWindow.requestIdleCallback) {
          const id = idleWindow.requestIdleCallback(warmCache, {
            timeout: 4000
          });
          return () => idleWindow.cancelIdleCallback?.(id);
        }
        const t = window.setTimeout(warmCache, 2000);
        return () => window.clearTimeout(t);
      };
      let cleanupScheduler = _temp;
      const onLoad = () => {
        cleanupScheduler = scheduleWarmCache();
      };
      if (document.readyState === "complete") {
        cleanupScheduler = scheduleWarmCache();
      } else {
        window.addEventListener("load", onLoad, {
          once: true
        });
        cleanupScheduler = () => window.removeEventListener("load", onLoad);
      }
      return () => {
        cancelled = true;
        cleanupScheduler();
      };
    };
    $[16] = initializeCache;
    $[17] = settings?.loginScreenThumbnailImage;
    $[18] = settings?.loginScreenThumbnailVideo;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = settings?.loginScreenThumbnailImage;
  const t16 = settings?.loginScreenThumbnailVideo;
  let t17;
  if ($[20] !== initializeCache || $[21] !== t15 || $[22] !== t16) {
    t17 = [initializeCache, t15, t16];
    $[20] = initializeCache;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  useEffect(t14, t17);
  let t18;
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => {
      const unsubscribe = auth?.onAuthStateChanged(u => setIsLoggedIn(Boolean(u)));
      return () => unsubscribe?.();
    };
    t19 = [];
    $[24] = t18;
    $[25] = t19;
  } else {
    t18 = $[24];
    t19 = $[25];
  }
  useEffect(t18, t19);
  let t20;
  if ($[26] !== profileData || $[27] !== redirectToPlayStore) {
    t20 = () => {
      if (!profileData?.user) {
        return;
      }
      if (isPremiumUser(profileData.user)) {
        redirectToPlayStore();
      }
    };
    $[26] = profileData;
    $[27] = redirectToPlayStore;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== initialQuery || $[30] !== profileData || $[31] !== redirectToPlayStore || $[32] !== router) {
    t21 = [initialQuery, profileData, redirectToPlayStore, router];
    $[29] = initialQuery;
    $[30] = profileData;
    $[31] = redirectToPlayStore;
    $[32] = router;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  useEffect(t20, t21);
  let t22;
  let t23;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => {
      const video = videoRef.current;
      if (!video) {
        return;
      }
      let hls = null;
      videoLoadStart.current = performance.now();
      if (Hls.isSupported()) {
        hls = new Hls({
          startLevel: -1
        });
        hls.loadSource(HLS_URL);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play().catch(_temp2);
        });
      } else {
        if (video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = HLS_URL;
          video.addEventListener("loadedmetadata", () => {
            video.play().catch(_temp3);
          });
        }
      }
      return () => {
        hls?.destroy();
      };
    };
    t23 = [];
    $[34] = t22;
    $[35] = t23;
  } else {
    t22 = $[34];
    t23 = $[35];
  }
  useEffect(t22, t23);
  let t24;
  let t25;
  if ($[36] !== utmTrackingParams) {
    t24 = () => {
      const video_0 = videoRef.current;
      if (!video_0) {
        return;
      }
      const onCanPlay = () => {
        const loadTime = Math.round(performance.now() - videoLoadStart.current);
        trackAnalyticsEvent("WEB_PAYMENT_SCREEN_MEDIA", {
          type: "video",
          load_time: loadTime,
          ...utmTrackingParams
        });
      };
      const onPlay = () => {
        trackAnalyticsEvent("WEB_PAYMENT_SCREEN_VIDEO_PLAY", {
          timestamp: video_0.currentTime,
          ...utmTrackingParams
        });
      };
      const onPause = () => {
        trackAnalyticsEvent("WEB_PAYMENT_SCREEN_VIDEO_PAUSE", {
          timestamp: video_0.currentTime,
          ...utmTrackingParams
        });
      };
      video_0.addEventListener("canplay", onCanPlay, {
        once: true
      });
      video_0.addEventListener("play", onPlay);
      video_0.addEventListener("pause", onPause);
      return () => {
        video_0.removeEventListener("canplay", onCanPlay);
        video_0.removeEventListener("play", onPlay);
        video_0.removeEventListener("pause", onPause);
      };
    };
    t25 = [utmTrackingParams];
    $[36] = utmTrackingParams;
    $[37] = t24;
    $[38] = t25;
  } else {
    t24 = $[37];
    t25 = $[38];
  }
  useEffect(t24, t25);
  let t26;
  if ($[39] !== isMuted || $[40] !== utmTrackingParams) {
    t26 = () => {
      const video_1 = videoRef.current;
      if (!video_1) {
        return;
      }
      const next = !isMuted;
      video_1.muted = next;
      setIsMuted(next);
      trackAnalyticsEvent(next ? "WEB_PAYMENT_SCREEN_VIDEO_MUTED" : "WEB_PAYMENT_SCREEN_VIDEO_UNMUTED", utmTrackingParams);
    };
    $[39] = isMuted;
    $[40] = utmTrackingParams;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  const toggleMute = t26;
  let t27;
  if ($[42] !== defaultPaymentApp || $[43] !== initialQuery || $[44] !== isLoggedIn || $[45] !== paymentStartPayment || $[46] !== plans || $[47] !== redirectToPlayStore || $[48] !== router || $[49] !== selectedPlanIndex || $[50] !== user || $[51] !== utmTrackingParams) {
    t27 = async t28 => {
      const skipLoginCheck = t28 === undefined ? false : t28;
      if (!plans[selectedPlanIndex]) {
        return;
      }
      const plan = plans[selectedPlanIndex];
      trackAnalyticsEvent("WEB_SUBSCRIBE_BUTTON_CLICKED", {
        plan_name: plan?.name,
        plan_id: plan?._id,
        price: plan?.price,
        currency: "INR",
        ...utmTrackingParams
      });
      if (defaultPaymentApp === "DEFAULT") {
        setIsPaymentOpen(true);
        return;
      }
      if (!isLoggedIn && !skipLoginCheck) {
        const params = buildUrlParams(initialQuery, CONTENT_ROUTE_KEYS, {
          [URL_PARAMS.PLAN]: selectedPlanIndex.toString(),
          [URL_PARAMS.AUTO]: "1",
          [URL_PARAMS.PAYMENT_APP]: defaultPaymentApp,
          [URL_PARAMS.RETURN_PATH]: currentPath
        });
        router.push(`/auth/login?${params}`);
        return;
      }
      await paymentStartPayment({
        plan,
        user: user || undefined,
        method: "APP",
        upiApp: defaultPaymentApp,
        utmTrackingParams,
        sourcePath: sessionStorage.getItem("landingPath") || undefined,
        onSuccess: () => redirectToPlayStore(),
        onError: _temp4
      });
    };
    $[42] = defaultPaymentApp;
    $[43] = initialQuery;
    $[44] = isLoggedIn;
    $[45] = paymentStartPayment;
    $[46] = plans;
    $[47] = redirectToPlayStore;
    $[48] = router;
    $[49] = selectedPlanIndex;
    $[50] = user;
    $[51] = utmTrackingParams;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  const handlePayment = t27;
  if (!plans.length) {
    let t28;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <div className="bg-v3-page h-dvh w-full text-white flex items-center justify-center"><p>No plans available</p></div>;
      $[53] = t28;
    } else {
      t28 = $[53];
    }
    return t28;
  }
  const selectedPlan = plans[selectedPlanIndex];
  if (isCoupon) {
    let t28;
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = {
        fontFamily: "var(--font-barlow), sans-serif"
      };
      $[54] = t28;
    } else {
      t28 = $[54];
    }
    let t29;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = <span className="text-gold-gradient font-extrabold">UNLIMITED</span>;
      $[55] = t29;
    } else {
      t29 = $[55];
    }
    let t30;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t30 = <br />;
      $[56] = t30;
    } else {
      t30 = $[56];
    }
    let t31;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
      t31 = <div className="w-full px-4 text-center"><h1 className="v12-coupon-heading" style={t28}>{"Watch "}{t29}{" Dramas"}{t30}{"for "}<span className="text-gold-gradient font-extrabold">FREE</span></h1></div>;
      $[57] = t31;
    } else {
      t31 = $[57];
    }
    let t32;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
      t32 = <video ref={videoRef} poster={VIDEO_POSTER} className="absolute inset-0 h-full w-full object-cover" muted={true} loop={true} playsInline={true} preload="auto" />;
      $[58] = t32;
    } else {
      t32 = $[58];
    }
    const t33 = isMuted ? "Unmute" : "Mute";
    let t34;
    if ($[59] !== isMuted) {
      t34 = isMuted ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5Z" /><line x1="23" y1="9" x2="17" y2="15" /><line x1="17" y1="9" x2="23" y2="15" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5Z" /><path d="M15.54 8.46a5 5 0 0 1 0 7.07" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14" /></svg>;
      $[59] = isMuted;
      $[60] = t34;
    } else {
      t34 = $[60];
    }
    let t35;
    if ($[61] !== t33 || $[62] !== t34 || $[63] !== toggleMute) {
      t35 = <div className="relative w-full shrink-0 overflow-hidden rounded-2xl border-2 border-white/50 shadow-video-card aspect-video">{t32}<button onClick={toggleMute} className="absolute bottom-2 right-2 z-[3] flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-0 bg-black/50 text-white transition-colors hover:bg-black/70" aria-label={t33}>{t34}</button></div>;
      $[61] = t33;
      $[62] = t34;
      $[63] = toggleMute;
      $[64] = t35;
    } else {
      t35 = $[64];
    }
    let t36;
    if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
      t36 = <div className="v12-coupon-bharat-badge"><span>EXCLUSIVELY MADE FOR BHARAT</span><img src="/IN.svg" alt="India flag" className="h-4 w-4 shrink-0" /></div>;
      $[65] = t36;
    } else {
      t36 = $[65];
    }
    let t37;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t37 = <div className="v12-coupon-timeline"><span className="v12-coupon-dot v12-coupon-dot-green" /><span className="v12-coupon-line" /><span className="v12-coupon-dot v12-coupon-dot-gold" /></div>;
      $[66] = t37;
    } else {
      t37 = $[66];
    }
    let t38;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
      t38 = <div className="v12-coupon-step"><p className="v12-coupon-step-title">Now: Activate Trial</p><p className="v12-coupon-step-copy">Start watching. ₹1 to verify, refunded instantly.</p></div>;
      $[67] = t38;
    } else {
      t38 = $[67];
    }
    let t39;
    if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
      t39 = <p className="v12-coupon-step-title">Day 2: Membership Starts</p>;
      $[68] = t39;
    } else {
      t39 = $[68];
    }
    let t40;
    if ($[69] !== planMonths) {
      t40 = <p className="v12-coupon-step-copy">Auto-upgraded to premium <span className="line-through decoration-[#ff3b30] decoration-2 opacity-75 font-medium">{planMonths} mo plan @ ₹{V12_COUPON_ORIGINAL_PRICE}.</span></p>;
      $[69] = planMonths;
      $[70] = t40;
    } else {
      t40 = $[70];
    }
    let t41;
    if ($[71] !== planMonths) {
      t41 = <span className="text-[14px] font-bold text-[#FFD86B]/90">for first {planMonths} months</span>;
      $[71] = planMonths;
      $[72] = t41;
    } else {
      t41 = $[72];
    }
    let t42;
    if ($[73] !== price || $[74] !== t41) {
      t42 = <span className="text-[18px] font-black text-transparent bg-clip-text bg-gradient-to-r from-[#FFD86B] to-[#F59E0B]">₹{price} {t41}</span>;
      $[73] = price;
      $[74] = t41;
      $[75] = t42;
    } else {
      t42 = $[75];
    }
    let t43;
    if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
      t43 = <span className="bg-gradient-to-r from-[#17b26a] to-[#059669] text-white text-[12px] font-black px-2 py-1 rounded-md shadow-[0_2px_8px_rgba(23,178,106,0.4)] uppercase tracking-wide">Save ₹200</span>;
      $[76] = t43;
    } else {
      t43 = $[76];
    }
    let t44;
    if ($[77] !== t42) {
      t44 = <div className="flex flex-col gap-1.5 mt-2"><div className="flex items-center gap-2 flex-wrap">{t42}{t43}</div></div>;
      $[77] = t42;
      $[78] = t44;
    } else {
      t44 = $[78];
    }
    let t45;
    if ($[79] !== t40 || $[80] !== t44) {
      t45 = <div className="w-full"><div className="v12-coupon-card"><div className="v12-coupon-card-grid">{t37}<div className="min-w-0">{t38}<div className="v12-coupon-step">{t39}{t40}{t44}</div></div></div></div></div>;
      $[79] = t40;
      $[80] = t44;
      $[81] = t45;
    } else {
      t45 = $[81];
    }
    let t46;
    if ($[82] !== t35 || $[83] !== t45) {
      t46 = <div className="flex w-full min-h-0 flex-col items-center gap-8 h-920:gap-7 h-800:gap-6 h-750:gap-5 h-700:gap-4">{t31}{t35}{t36}{t45}</div>;
      $[82] = t35;
      $[83] = t45;
      $[84] = t46;
    } else {
      t46 = $[84];
    }
    let t47;
    let t48;
    let t49;
    if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
      t47 = <span className="v12-coupon-trust-copy">Trusted by</span>;
      t48 = <span className="v12-coupon-trust-count">2Cr+</span>;
      t49 = <span className="v12-coupon-trust-copy">Fans on</span>;
      $[85] = t47;
      $[86] = t48;
      $[87] = t49;
    } else {
      t47 = $[85];
      t48 = $[86];
      t49 = $[87];
    }
    let t50;
    if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
      t50 = <div className="mt-auto flex items-center justify-center gap-[6px] pt-[46px] text-center h-920:pt-9 h-850:pt-8 h-800:pt-6 h-750:pt-4 h-700:pt-3">{t47}{t48}{t49}<div className="flex items-center gap-[7px]"><img src="/youtube.png" alt="YouTube" className="h-4 w-4 object-contain" /><img src="/facebook.png" alt="Facebook" className="h-4 w-4 object-contain" /><img src="/instagram.png" alt="Instagram" className="h-4 w-4 object-contain" /></div></div>;
      $[88] = t50;
    } else {
      t50 = $[88];
    }
    let t51;
    if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
      t51 = <span className="v12-coupon-secure-label">Securely with UPI:</span>;
      $[89] = t51;
    } else {
      t51 = $[89];
    }
    let t52;
    if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
      t52 = <div className="flex items-center gap-[6px]">{t51}<div className="flex items-center gap-1">{["GPay", "PayTM", "PhonePe", "Others"].map(_temp5)}</div></div>;
      $[90] = t52;
    } else {
      t52 = $[90];
    }
    let t53;
    if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
      t53 = () => setIsPaymentOpen(true);
      $[91] = t53;
    } else {
      t53 = $[91];
    }
    const t54 = APP_CONFIG[defaultPaymentApp]?.icon || FALLBACK_UPI_ICON;
    let t55;
    if ($[92] !== defaultPaymentApp || $[93] !== t54) {
      t55 = <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white"><img src={t54} alt={defaultPaymentApp} className="h-[22px] w-[22px] object-contain" /></div>;
      $[92] = defaultPaymentApp;
      $[93] = t54;
      $[94] = t55;
    } else {
      t55 = $[94];
    }
    let t56;
    if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
      t56 = <span className="v12-coupon-selector-label">Pay via</span>;
      $[95] = t56;
    } else {
      t56 = $[95];
    }
    const t57 = APP_CONFIG[defaultPaymentApp]?.label || "Other UPI";
    let t58;
    if ($[96] !== t57) {
      t58 = <div className="flex flex-col items-start">{t56}<span className="v12-coupon-selector-value">{t57}</span></div>;
      $[96] = t57;
      $[97] = t58;
    } else {
      t58 = $[97];
    }
    let t59;
    if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
      t59 = <ChevronDown size={16} className="text-white/70 shrink-0" />;
      $[98] = t59;
    } else {
      t59 = $[98];
    }
    let t60;
    if ($[99] !== t55 || $[100] !== t58) {
      t60 = <button onClick={t53} className="v12-coupon-selector">{t55}{t58}{t59}</button>;
      $[99] = t55;
      $[100] = t58;
      $[101] = t60;
    } else {
      t60 = $[101];
    }
    let t61;
    if ($[102] !== handlePayment) {
      t61 = () => handlePayment();
      $[102] = handlePayment;
      $[103] = t61;
    } else {
      t61 = $[103];
    }
    const t62 = paymentProcessing ? "Processing..." : "Start Free Trial";
    let t63;
    if ($[104] !== paymentProcessing || $[105] !== t61 || $[106] !== t62) {
      t63 = <button onClick={t61} disabled={paymentProcessing} className="v12-coupon-cta">{t62}</button>;
      $[104] = paymentProcessing;
      $[105] = t61;
      $[106] = t62;
      $[107] = t63;
    } else {
      t63 = $[107];
    }
    let t64;
    if ($[108] !== t60 || $[109] !== t63) {
      t64 = <div className="v12-coupon-footer w-full border-t border-white/20 pt-4">{t60}{t63}</div>;
      $[108] = t60;
      $[109] = t63;
      $[110] = t64;
    } else {
      t64 = $[110];
    }
    let t65;
    if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
      t65 = <p className="v12-coupon-disclaimer">🔒 Your ₹5 verification charge is refunded instantly.</p>;
      $[111] = t65;
    } else {
      t65 = $[111];
    }
    let t66;
    if ($[112] !== t64) {
      t66 = <div className="flex w-full flex-col items-center gap-3 pt-[46px] h-920:pt-9 h-850:pt-8 h-800:pt-6 h-750:pt-4 h-700:pt-3 h-700:gap-2">{t52}{t64}{t65}</div>;
      $[112] = t64;
      $[113] = t66;
    } else {
      t66 = $[113];
    }
    let t67;
    if ($[114] !== t46 || $[115] !== t66) {
      t67 = <div className="mx-auto flex h-dvh w-full max-w-[402px] flex-col items-center overflow-hidden px-4 pt-3"><div className="flex w-full flex-1 min-h-0 flex-col items-center py-9 h-800:py-6 h-750:py-4 h-700:py-2">{t46}{t50}{t66}</div></div>;
      $[114] = t46;
      $[115] = t66;
      $[116] = t67;
    } else {
      t67 = $[116];
    }
    let t68;
    if ($[117] !== paymentProcessing) {
      t68 = <LoadingOverlay isVisible={paymentProcessing} />;
      $[117] = paymentProcessing;
      $[118] = t68;
    } else {
      t68 = $[118];
    }
    const t69 = paymentStatus === "pending" && paymentSubId ? "pending" : paymentStatus === "failure" ? "failure" : null;
    const t70 = selectedPlan?.freeTrialAmount;
    let t71;
    if ($[119] !== initialQuery || $[120] !== router) {
      t71 = () => router.push(buildRoute(currentPath, initialQuery, CONTENT_ROUTE_KEYS));
      $[119] = initialQuery;
      $[120] = router;
      $[121] = t71;
    } else {
      t71 = $[121];
    }
    const t72 = paymentStatus === "pending";
    let t73;
    if ($[122] !== defaultPaymentApp || $[123] !== paymentCancel || $[124] !== paymentTimer || $[125] !== t69 || $[126] !== t70 || $[127] !== t71 || $[128] !== t72) {
      t73 = <PaymentStatusUI status={t69} amount={t70} timer={paymentTimer} appName={defaultPaymentApp} cancelPayment={paymentCancel} onNavigate={t71} isPending={t72} onCancelled={undefined} />;
      $[122] = defaultPaymentApp;
      $[123] = paymentCancel;
      $[124] = paymentTimer;
      $[125] = t69;
      $[126] = t70;
      $[127] = t71;
      $[128] = t72;
      $[129] = t73;
    } else {
      t73 = $[129];
    }
    let t74;
    if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
      t74 = () => setIsPaymentOpen(false);
      $[130] = t74;
    } else {
      t74 = $[130];
    }
    const t75 = selectedPlan || null;
    const t76 = selectedPlan?.freeTrialAmount;
    let t77;
    if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
      t77 = app_0 => setDefaultPaymentApp(app_0);
      $[131] = t77;
    } else {
      t77 = $[131];
    }
    let t78;
    if ($[132] !== defaultPaymentApp || $[133] !== isPaymentOpen || $[134] !== selectedPlanIndex || $[135] !== t75 || $[136] !== t76 || $[137] !== user) {
      t78 = <PaymentModal open={isPaymentOpen} onClose={t74} plan={t75} planIndex={selectedPlanIndex} user={user} amount={t76} onPaymentStart={t77} autoStart={false} defaultApp={defaultPaymentApp} couponCode={null} onCancelled={undefined} />;
      $[132] = defaultPaymentApp;
      $[133] = isPaymentOpen;
      $[134] = selectedPlanIndex;
      $[135] = t75;
      $[136] = t76;
      $[137] = user;
      $[138] = t78;
    } else {
      t78 = $[138];
    }
    let t79;
    if ($[139] !== t67 || $[140] !== t68 || $[141] !== t73 || $[142] !== t78) {
      t79 = <div className={`bg-v3-page h-dvh w-full overflow-hidden text-white ${barlow.variable}`}>{t67}{t68}{t73}{t78}</div>;
      $[139] = t67;
      $[140] = t68;
      $[141] = t73;
      $[142] = t78;
      $[143] = t79;
    } else {
      t79 = $[143];
    }
    return t79;
  }
  let t28;
  if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      fontFamily: "var(--font-barlow), sans-serif"
    };
    $[144] = t28;
  } else {
    t28 = $[144];
  }
  let t29;
  if ($[145] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="shrink-0 pt-4 pb-3 text-center px-4"><h1 className="text-[36px] font-bold leading-[40px] text-white" style={t28}>{"Start "}<span className="text-[#ffba27]">Free</span>{" Trial"}</h1></div>;
    $[145] = t29;
  } else {
    t29 = $[145];
  }
  let t30;
  if ($[146] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="inline-grid place-items-start -mr-[8px] relative shrink-0"><img src={IMG_AVATAR_1} alt="" className="size-8 opacity-80" /></div>;
    $[146] = t30;
  } else {
    t30 = $[146];
  }
  let t31;
  if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="flex items-center leading-[0] pr-[8px] shrink-0">{t30}<div className="inline-grid place-items-start -mr-[8px] relative shrink-0"><img src={IMG_AVATAR_2} alt="" className="size-8 opacity-80" /></div></div>;
    $[147] = t31;
  } else {
    t31 = $[147];
  }
  let t32;
  if ($[148] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <span className="overflow-clip relative shrink-0 size-[12px] flex items-center justify-center"><span className="size-[6px] rounded-full bg-[#17b26a] animate-blink" /></span>;
    $[148] = t32;
  } else {
    t32 = $[148];
  }
  let t33;
  if ($[149] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <span className="font-extrabold text-[#ffba27]">🎉</span>;
    $[149] = t33;
  } else {
    t33 = $[149];
  }
  let t34;
  if ($[150] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <span className="font-extrabold text-[#ffba27]">50 People</span>;
    $[150] = t34;
  } else {
    t34 = $[150];
  }
  let t35;
  if ($[151] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <span>Subscribed in</span>;
    $[151] = t35;
  } else {
    t35 = $[151];
  }
  let t36;
  if ($[152] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="shrink-0 w-full flex justify-center pb-3"><div className="v12-social-bar w-full max-w-sm flex items-center justify-center gap-[6px] h-12 px-4">{t31}{t32}<p className="text-[12px] leading-[18px] text-[rgba(255,255,255,0.9)] whitespace-nowrap shrink-0">{t33}{" "}{t34}{" "}{t35}{" "}<span className="font-extrabold text-[#ffba27]">last hour !</span></p></div></div>;
    $[152] = t36;
  } else {
    t36 = $[152];
  }
  let t37;
  let t38;
  if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <video ref={videoRef} poster={VIDEO_POSTER} className="absolute inset-0 h-full w-full object-cover" muted={true} loop={true} playsInline={true} preload="auto" />;
    t38 = <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#0d142a] to-transparent pointer-events-none" />;
    $[153] = t37;
    $[154] = t38;
  } else {
    t37 = $[153];
    t38 = $[154];
  }
  const t39 = isMuted ? "Unmute" : "Mute";
  let t40;
  if ($[155] !== isMuted) {
    t40 = isMuted ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5Z" /><line x1="23" y1="9" x2="17" y2="15" /><line x1="17" y1="9" x2="23" y2="15" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5Z" /><path d="M15.54 8.46a5 5 0 0 1 0 7.07" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14" /></svg>;
    $[155] = isMuted;
    $[156] = t40;
  } else {
    t40 = $[156];
  }
  let t41;
  if ($[157] !== t39 || $[158] !== t40 || $[159] !== toggleMute) {
    t41 = <div className="relative w-full shrink-0 h-[260px] h-800:h-[240px] h-750:h-[220px] h-700:h-[200px]">{t37}{t38}<button onClick={toggleMute} className="absolute top-2 right-2 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-0 bg-black/50 text-white transition-colors hover:bg-black/70" aria-label={t39}>{t40}</button></div>;
    $[157] = t39;
    $[158] = t40;
    $[159] = toggleMute;
    $[160] = t41;
  } else {
    t41 = $[160];
  }
  let t42;
  if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="w-[4px] shrink-0" style={{
      background: "linear-gradient(180deg, #34d399, #059669)",
      boxShadow: "0 0 16px rgba(52,211,153,0.5)"
    }} />;
    $[161] = t42;
  } else {
    t42 = $[161];
  }
  let t43;
  if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="pointer-events-none absolute inset-y-0 left-0 w-[120px]" style={{
      background: "radial-gradient(ellipse at left center, rgba(52,211,153,0.18) 0%, transparent 70%)"
    }} />;
    $[162] = t43;
  } else {
    t43 = $[162];
  }
  let t44;
  if ($[163] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="flex-1 min-w-0 flex items-center"><p className="text-[15px] h-750:text-[14px] font-semibold leading-[1.25] tracking-[-0.01em] text-[#f8fafc]">Pay ₹1 — Instant Refund</p></div>;
    $[163] = t44;
  } else {
    t44 = $[163];
  }
  let t45;
  if ($[164] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <div className="relative rounded-[14px] border border-white/[0.06] bg-gradient-to-br from-white/[0.04] to-white/[0.01] overflow-hidden flex items-stretch flex-1 min-h-0">{t42}{t43}<div className="flex-1 flex items-center gap-[12px] px-4 py-[10px] h-750:py-[8px] h-700:py-[6px] relative min-w-0">{t44}<div className="shrink-0 w-[48px] h-[48px] h-750:w-[42px] h-750:h-[42px] h-700:w-[38px] h-700:h-[38px] rounded-[12px] bg-black/40 border flex items-center justify-center" style={{
          borderColor: "rgba(52,211,153,0.25)",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04), 0 4px 12px rgba(52,211,153,0.2)"
        }}><IconRefund size={32} from="#34d399" to="#059669" /></div></div></div>;
    $[164] = t45;
  } else {
    t45 = $[164];
  }
  let t46;
  if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="w-[4px] shrink-0" style={{
      background: "linear-gradient(180deg, #FFD86B, #F59E0B)",
      boxShadow: "0 0 16px rgba(255,186,39,0.5)"
    }} />;
    $[165] = t46;
  } else {
    t46 = $[165];
  }
  let t47;
  if ($[166] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <div className="pointer-events-none absolute inset-y-0 left-0 w-[120px]" style={{
      background: "radial-gradient(ellipse at left center, rgba(255,186,39,0.2) 0%, transparent 70%)"
    }} />;
    $[166] = t47;
  } else {
    t47 = $[166];
  }
  const t48 = trialDays === 1 ? "day" : "days";
  let t49;
  if ($[167] !== t48 || $[168] !== trialDays) {
    t49 = <div className="flex-1 min-w-0 flex items-center"><p className="text-[15px] h-750:text-[14px] font-semibold leading-[1.25] tracking-[-0.01em] text-[#f8fafc]">Watch free for {trialDays} {t48}</p></div>;
    $[167] = t48;
    $[168] = trialDays;
    $[169] = t49;
  } else {
    t49 = $[169];
  }
  let t50;
  if ($[170] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <div className="shrink-0 w-[48px] h-[48px] h-750:w-[42px] h-750:h-[42px] h-700:w-[38px] h-700:h-[38px] rounded-[12px] bg-black/40 border flex items-center justify-center" style={{
      borderColor: "rgba(255,186,39,0.25)",
      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04), 0 4px 12px rgba(255,186,39,0.2)"
    }}><IconPlaySpark size={32} from="#FFD86B" to="#F59E0B" /></div>;
    $[170] = t50;
  } else {
    t50 = $[170];
  }
  let t51;
  if ($[171] !== t49) {
    t51 = <div className="relative rounded-[14px] border border-white/[0.06] bg-gradient-to-br from-white/[0.04] to-white/[0.01] overflow-hidden flex items-stretch flex-1 min-h-0">{t46}{t47}<div className="flex-1 flex items-center gap-[12px] px-4 py-[10px] h-750:py-[8px] h-700:py-[6px] relative min-w-0">{t49}{t50}</div></div>;
    $[171] = t49;
    $[172] = t51;
  } else {
    t51 = $[172];
  }
  let t52;
  if ($[173] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <div className="w-[4px] shrink-0" style={{
      background: "linear-gradient(180deg, #c4b5fd, #7c3aed)",
      boxShadow: "0 0 16px rgba(167,139,250,0.5)"
    }} />;
    $[173] = t52;
  } else {
    t52 = $[173];
  }
  let t53;
  if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <div className="pointer-events-none absolute inset-y-0 left-0 w-[120px]" style={{
      background: "radial-gradient(ellipse at left center, rgba(167,139,250,0.18) 0%, transparent 70%)"
    }} />;
    $[174] = t53;
  } else {
    t53 = $[174];
  }
  let t54;
  if ($[175] !== planMonths || $[176] !== price) {
    t54 = <div className="flex-1 min-w-0 flex items-center"><p className="text-[15px] h-750:text-[14px] font-semibold leading-[1.25] tracking-[-0.01em] text-[#f8fafc]">Autopay ₹{price}/{planMonths} months after trial</p></div>;
    $[175] = planMonths;
    $[176] = price;
    $[177] = t54;
  } else {
    t54 = $[177];
  }
  let t55;
  if ($[178] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <div className="shrink-0 w-[48px] h-[48px] h-750:w-[42px] h-750:h-[42px] h-700:w-[38px] h-700:h-[38px] rounded-[12px] bg-black/40 border flex items-center justify-center" style={{
      borderColor: "rgba(167,139,250,0.25)",
      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04), 0 4px 12px rgba(167,139,250,0.2)"
    }}><IconAutoPay size={32} from="#c4b5fd" to="#7c3aed" /></div>;
    $[178] = t55;
  } else {
    t55 = $[178];
  }
  let t56;
  if ($[179] !== t54) {
    t56 = <div className="relative rounded-[14px] border border-white/[0.06] bg-gradient-to-br from-white/[0.04] to-white/[0.01] overflow-hidden flex items-stretch flex-1 min-h-0">{t52}{t53}<div className="flex-1 flex items-center gap-[12px] px-4 py-[10px] h-750:py-[8px] h-700:py-[6px] relative min-w-0">{t54}{t55}</div></div>;
    $[179] = t54;
    $[180] = t56;
  } else {
    t56 = $[180];
  }
  let t57;
  if ($[181] !== t51 || $[182] !== t56) {
    t57 = <div className="flex-1 min-h-0 overflow-hidden flex flex-col px-4 py-2 h-700:py-1"><div className="w-full max-w-sm mx-auto flex flex-col gap-[8px] h-700:gap-[6px] flex-1 min-h-0">{t45}{t51}{t56}</div></div>;
    $[181] = t51;
    $[182] = t56;
    $[183] = t57;
  } else {
    t57 = $[183];
  }
  let t58;
  if ($[184] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = () => setIsPaymentOpen(true);
    $[184] = t58;
  } else {
    t58 = $[184];
  }
  const t59 = APP_CONFIG[defaultPaymentApp]?.icon || FALLBACK_UPI_ICON;
  let t60;
  if ($[185] !== defaultPaymentApp || $[186] !== t59) {
    t60 = <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white"><img src={t59} alt={defaultPaymentApp} className="h-[22px] w-[22px] object-contain" /></div>;
    $[185] = defaultPaymentApp;
    $[186] = t59;
    $[187] = t60;
  } else {
    t60 = $[187];
  }
  let t61;
  if ($[188] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <span className="text-xs text-white/80">Pay via</span>;
    $[188] = t61;
  } else {
    t61 = $[188];
  }
  const t62 = APP_CONFIG[defaultPaymentApp]?.label || "Other UPI";
  let t63;
  if ($[189] !== t62) {
    t63 = <div className="flex flex-col items-start leading-normal">{t61}<span className="text-sm font-semibold text-white">{t62}</span></div>;
    $[189] = t62;
    $[190] = t63;
  } else {
    t63 = $[190];
  }
  let t64;
  if ($[191] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <ChevronDown size={16} className="text-white/70" />;
    $[191] = t64;
  } else {
    t64 = $[191];
  }
  let t65;
  if ($[192] !== t60 || $[193] !== t63) {
    t65 = <button onClick={t58} className="cursor-pointer border-none bg-transparent transition shrink-0"><div className="flex items-center gap-2">{t60}{t63}{t64}</div></button>;
    $[192] = t60;
    $[193] = t63;
    $[194] = t65;
  } else {
    t65 = $[194];
  }
  let t66;
  if ($[195] !== handlePayment) {
    t66 = () => handlePayment();
    $[195] = handlePayment;
    $[196] = t66;
  } else {
    t66 = $[196];
  }
  let t67;
  if ($[197] !== paymentProcessing) {
    t67 = paymentProcessing ? "Processing..." : <>{"Start Trial"}<ChevronRight size={20} className="text-black shrink-0" /></>;
    $[197] = paymentProcessing;
    $[198] = t67;
  } else {
    t67 = $[198];
  }
  let t68;
  if ($[199] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = <div className="btn-shimmer" />;
    $[199] = t68;
  } else {
    t68 = $[199];
  }
  let t69;
  if ($[200] !== paymentProcessing || $[201] !== t66 || $[202] !== t67) {
    t69 = <button onClick={t66} disabled={paymentProcessing} className="v12-cta-btn group relative shrink-0 cursor-pointer overflow-hidden rounded-xl px-5 py-3 font-semibold text-lg leading-8 text-black shadow-gold-glow transition-colors disabled:opacity-70 flex items-center gap-1">{t67}{t68}</button>;
    $[200] = paymentProcessing;
    $[201] = t66;
    $[202] = t67;
    $[203] = t69;
  } else {
    t69 = $[203];
  }
  let t70;
  if ($[204] !== t65 || $[205] !== t69) {
    t70 = <div className="shrink-0 border-t border-white/20 px-4 pt-4 pb-6 h-800:pb-4 flex items-center justify-between gap-3">{t65}{t69}</div>;
    $[204] = t65;
    $[205] = t69;
    $[206] = t70;
  } else {
    t70 = $[206];
  }
  let t71;
  if ($[207] !== paymentProcessing) {
    t71 = <LoadingOverlay isVisible={paymentProcessing} />;
    $[207] = paymentProcessing;
    $[208] = t71;
  } else {
    t71 = $[208];
  }
  const t72 = paymentStatus === "pending" && paymentSubId ? "pending" : paymentStatus === "failure" ? "failure" : null;
  const t73 = selectedPlan?.freeTrialAmount;
  let t74;
  if ($[209] !== initialQuery || $[210] !== router) {
    t74 = () => router.push(buildRoute(currentPath, initialQuery, CONTENT_ROUTE_KEYS));
    $[209] = initialQuery;
    $[210] = router;
    $[211] = t74;
  } else {
    t74 = $[211];
  }
  const t75 = paymentStatus === "pending";
  let t76;
  if ($[212] !== defaultPaymentApp || $[213] !== paymentCancel || $[214] !== paymentTimer || $[215] !== t72 || $[216] !== t73 || $[217] !== t74 || $[218] !== t75) {
    t76 = <PaymentStatusUI status={t72} amount={t73} timer={paymentTimer} appName={defaultPaymentApp} cancelPayment={paymentCancel} onNavigate={t74} isPending={t75} onCancelled={undefined} />;
    $[212] = defaultPaymentApp;
    $[213] = paymentCancel;
    $[214] = paymentTimer;
    $[215] = t72;
    $[216] = t73;
    $[217] = t74;
    $[218] = t75;
    $[219] = t76;
  } else {
    t76 = $[219];
  }
  let t77;
  if ($[220] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = () => setIsPaymentOpen(false);
    $[220] = t77;
  } else {
    t77 = $[220];
  }
  const t78 = selectedPlan || null;
  const t79 = selectedPlan?.freeTrialAmount;
  let t80;
  if ($[221] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = app_1 => setDefaultPaymentApp(app_1);
    $[221] = t80;
  } else {
    t80 = $[221];
  }
  let t81;
  if ($[222] !== defaultPaymentApp || $[223] !== isPaymentOpen || $[224] !== selectedPlanIndex || $[225] !== t78 || $[226] !== t79 || $[227] !== user) {
    t81 = <PaymentModal open={isPaymentOpen} onClose={t77} plan={t78} planIndex={selectedPlanIndex} user={user} amount={t79} onPaymentStart={t80} autoStart={false} defaultApp={defaultPaymentApp} couponCode={null} onCancelled={undefined} />;
    $[222] = defaultPaymentApp;
    $[223] = isPaymentOpen;
    $[224] = selectedPlanIndex;
    $[225] = t78;
    $[226] = t79;
    $[227] = user;
    $[228] = t81;
  } else {
    t81 = $[228];
  }
  let t82;
  if ($[229] !== t41 || $[230] !== t57 || $[231] !== t70 || $[232] !== t71 || $[233] !== t76 || $[234] !== t81) {
    t82 = <div className={`bg-v3-page h-dvh w-full overflow-hidden text-white flex flex-col ${barlow.variable}`}>{t29}{t36}{t41}{t57}{t70}{t71}{t76}{t81}</div>;
    $[229] = t41;
    $[230] = t57;
    $[231] = t70;
    $[232] = t71;
    $[233] = t76;
    $[234] = t81;
    $[235] = t82;
  } else {
    t82 = $[235];
  }
  return t82;
}
function _temp5(app) {
  return <span key={app} className="v12-coupon-chip">{app}</span>;
}
function _temp4(error) {
  return console.error("Subscription payment error", error);
}
function _temp3() {}
function _temp2() {}
function _temp() {}